import axios, { AxiosResponse } from "axios";
import { BaseResponse, Pagination, Response } from "src/app/models/api.types";
import { CampaignModel } from "../models/Campaign.model";
import { DrawingModel, LuckyDrawDetailModel, LuckyDrawModel, LuckyDrawParticipantModel, LuckyDrawRuleModel, ParticipantCouponModel, ParticipantDetailModel, ParticipantSummaryModel, PrizeListModel, WinnersModel } from '../models/LuckyDraw.model';
import { SalesPromoModel, SalesPromoParticipant, SalesPromoPrizeModel, SalesPromoResult, SalesPromoRuleModel, SalesPromoSelectGiftModel, SalesPromoSelectGiftPrizesModel } from '../models/SalesPromo.model';

export const URL_CAMPAIGN = '/v1/cms/campaigns';
export const URL_CAMPAIGN_LUCKY_DRAW = `${URL_CAMPAIGN}/lucky-draw`;
export const URL_CAMPAIGN_LUCKY_DRAW_PRIZES = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/prizes`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_SUMMARY = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/summary`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/participants`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_EXPORT = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/participant-export`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_EXPORT_COUPON_DETAIL = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/coupon-report-export`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_EXPORT_COUPON_SUMMARY = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/coupon-summary-export`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_SUMMARY = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/participant-summary`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_DETAIL = (campaign_id: string, member_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/participants/${member_id}`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_COUPONS = (campaign_id: string, member_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/participants/${member_id}/coupons`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_DRAWING_DETAIL = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/drawing`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_DRAWING_DETAIL_PRIZE_LIST = (campaign_id: string, member_coupon_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/drawing/${member_coupon_id}/prizes`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_SET_AS_WINNERS = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/winners`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_WINNERS = (campaign_id: string, type: 'grand-prize'|'consolation') => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/${type}-winners`;
}
export const URL_CAMPAIGN_LUCKY_DRAW_WINNERS_EXPORT = (campaign_id: string) => {
  return `${URL_CAMPAIGN_LUCKY_DRAW}/${campaign_id}/winner-export`;
}

export const URL_CAMPAIGN_SALES_PROMO = `${URL_CAMPAIGN}/sales-promo`;
export const URL_CAMPAIGN_SALES_PROMO_PRIZES = (campaign_id?: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}/prizes`;
}
export const URL_CAMPAIGN_SALES_PROMO_PARTICIPANT = (campaign_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}/participants`;
}
export const URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_SUMMARY = (campaign_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}/participant-summary`;
}
export const URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_EXPORT = (campaign_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}/participant-export`;
}
export const URL_CAMPAIGN_SALES_PROMO_SUMMARY = (campaign_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}/summary`;
}
export const URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_DETAIL = (campaign_id: string, member_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO_PARTICIPANT(campaign_id)}/${member_id}`;
}
export const URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_MISSION = (campaign_id: string, member_id: string, mission_stamp_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_DETAIL(campaign_id, member_id)}/mission/${mission_stamp_id}/select-prize`;
}
export const URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_TRANSACTION = (campaign_id: string, member_id: string, member_sales_promo_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_DETAIL(campaign_id, member_id)}/member-sales-promos/${member_sales_promo_id}/select-prize`;
}
export const URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_RANDOMIZE = (campaign_id: string, member_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_DETAIL(campaign_id, member_id)}/random-prize`;
}
export const URL_CAMPAIGN_SALES_PROMO_WINNERS = (campaign_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}/winners`;
}
export const URL_CAMPAIGN_SALES_PROMO_WINNERS_EXPORT = (campaign_id: string) => {
  return `${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}/winners-export`;
}

// get campaign
export async function getCampaign(params: any, signal?: AbortSignal) {
  return axios.get<BaseResponse<Pagination<CampaignModel[]>>>(`${URL_CAMPAIGN}`, { params, signal });
}

// get campaign detail
export async function getCampaignDetail(id: string, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<CampaignModel>>>(`${URL_CAMPAIGN}/${id}`, { signal });
}

// save campaign
export function saveCampaign(params: CampaignModel) {
  if (!params.id) {
    return axios.post<BaseResponse<Response<CampaignModel>>>(URL_CAMPAIGN, params);
  }
  return axios.put<BaseResponse<Response<CampaignModel>>>(`${URL_CAMPAIGN}/${params.id}`, params);
}

// delete campaign
export async function deleteCampaign(id: string) {
  return axios.delete<BaseResponse<Response<{}>>>(`${URL_CAMPAIGN}/${id}`);
}

// get lucky draw
export async function getLuckyDrawList(params: any, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<LuckyDrawModel[]>>>> {
  return axios.get<BaseResponse<Pagination<LuckyDrawModel[]>>>(`${URL_CAMPAIGN_LUCKY_DRAW}`, { params, signal });
}

// get lucky draw prize list
export async function getLuckyDrawPrizeList(params: any, campaign_id: string, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<PrizeListModel[]>>>> {
  // return axios.get<BaseResponse<Pagination<PrizeListModel[]>>>(`${URL_CAMPAIGN_LUCKY_DRAW}`, { params, signal });
  return axios.get<BaseResponse<Pagination<PrizeListModel[]>>>(`${URL_CAMPAIGN_LUCKY_DRAW_PRIZES(campaign_id)}`, { params, signal });
}

export function submitPrize(campaign_id: string, params: any) {
  if (params.id) {
    return axios.put<BaseResponse<Response<PrizeListModel>>>(`${URL_CAMPAIGN_LUCKY_DRAW_PRIZES(campaign_id)}/${params.id}`, params);
  }
  return axios.post<BaseResponse<Response<any>>>(URL_CAMPAIGN_LUCKY_DRAW_PRIZES(campaign_id), params);
}

export function deleteLuckyDrawPrize(campaign_id: string, prize_id: string) {
  return axios.delete<BaseResponse<Response<PrizeListModel>>>(`${URL_CAMPAIGN_LUCKY_DRAW_PRIZES(campaign_id)}/${prize_id}`);
}

// get Lucky Draw Rule
export async function getLuckyDrawRule(id: string, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<LuckyDrawRuleModel[]>>>> {
  return axios.get<BaseResponse<Pagination<LuckyDrawRuleModel[]>>>(`${URL_CAMPAIGN_LUCKY_DRAW}/${id}/rules`, { signal });
}

// save Lucky Draw General Data
export function saveLuckyDrawGeneral(params: LuckyDrawModel) {
  if (!params.id) {
    return axios.post<BaseResponse<Response<LuckyDrawModel>>>(URL_CAMPAIGN_LUCKY_DRAW, params);
  }
  return axios.put<BaseResponse<Response<LuckyDrawModel>>>(`${URL_CAMPAIGN_LUCKY_DRAW}/${params.id}`, params);
}

// save Lucky Draw Rule Data
export function saveLuckyDrawRule(id: string, params: LuckyDrawModel[]) {
  return axios.post<BaseResponse<Pagination<LuckyDrawModel[]>>>(`${URL_CAMPAIGN_LUCKY_DRAW}/${id}/rules`, params);
}

// save Submit Summary Lucky Draw
export function submitSummaryLuckyDraw(campaign_id: string) {
  return axios.patch<BaseResponse<Response<LuckyDrawModel>>>(`${URL_CAMPAIGN_LUCKY_DRAW_SUMMARY(campaign_id)}`);
}

// delete lucky draw
export function deleteLuckyDraw(id: string) {
  return axios.delete<BaseResponse<Response<LuckyDrawDetailModel>>>(`${URL_CAMPAIGN_LUCKY_DRAW}/${id}`);
}

// get getLuckyDrawDetail
export async function getLuckyDrawDetail(id: string, params: any, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<LuckyDrawDetailModel>>>(`${URL_CAMPAIGN_LUCKY_DRAW}/${id}`, { params, signal });
}

// get getLuckyDrawParticipantList
export async function getLuckyDrawParticipantList(campaign_id: string, params: any, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<LuckyDrawParticipantModel[]>>>> {
  return axios.get<BaseResponse<Pagination<LuckyDrawParticipantModel[]>>>(URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT(campaign_id), { params, signal });
}

// get getLuckyDrawParticipantSummary
export async function getLuckyDrawParticipantSummary(campaign_id: string, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<ParticipantSummaryModel>>>(URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_SUMMARY(campaign_id), { signal });
}

// get getParticipantDetail
export async function getParticipantDetail(campaign_id: string, member_id: string, params: any, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<ParticipantDetailModel>>>(URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_DETAIL(campaign_id, member_id), { params, signal });
}

// get getLuckyDrawParticipantCouponList
export async function getLuckyDrawParticipantCouponList(campaign_id: string, member_id: string, params: any, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<ParticipantCouponModel[]>>>> {
  return axios.get<BaseResponse<Pagination<ParticipantCouponModel[]>>>(URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_COUPONS(campaign_id, member_id), { params, signal });
}

// download export list participant
export async function getExportListParticipant(campaign_id: string, params?: any) {
  return axios.get<Blob>(URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_EXPORT(campaign_id), { params, responseType: 'blob' });
}

export async function getExportParticipantCouponDetail(campaign_id: string, params?: any) {
  return axios.get<Blob>(URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_EXPORT_COUPON_DETAIL(campaign_id), { params, responseType: 'blob' });
}

export async function getExportParticipantCouponSummary(campaign_id: string, params?: any) {
  return axios.get<Blob>(URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_EXPORT_COUPON_SUMMARY(campaign_id), { params, responseType: 'blob' });
}

export function submitPrintCoupon(campaign_id: string, member_id: string, action_type: 'print' | 'reprint', params: any) {
  return axios.post<BaseResponse<Pagination<any>>>(`${URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_DETAIL(campaign_id, member_id)}/${action_type}`, params);
}

export function submitPostPrintCoupon(campaign_id: string, member_id: string, params: any) {
  return axios.post<BaseResponse<Pagination<any>>>(`${URL_CAMPAIGN_LUCKY_DRAW_PARTICIPANT_DETAIL(campaign_id, member_id)}/post-print`, params);
}

export async function executePrintCoupon(params: any, key: string) {
  const REACT_APP_API_PRINT = process.env.REACT_APP_API_PRINT
  const REACT_APP_API_PRINT_TIMEOUT: number = process.env.REACT_APP_API_PRINT_TIMEOUT ? +process.env.REACT_APP_API_PRINT_TIMEOUT : 5000

  let controller: AbortController | null = null;
  let timeoutId: NodeJS.Timeout | null = null;

  if (key === 'check') {
    controller = new AbortController();
    timeoutId = setTimeout(() => controller?.abort(), REACT_APP_API_PRINT_TIMEOUT); // Set timeout for timeout API
  }

  try {
    const response = await fetch(`${REACT_APP_API_PRINT}/${key}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params),
      signal: controller?.signal,
    });

    if (timeoutId) clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error saving lucky draw:", error);
    throw error;
  }
}

// get getLuckyDrawDetailDrawing
export async function getLuckyDrawDetailDrawing(campaig_id: string, params: any, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<DrawingModel>>>(URL_CAMPAIGN_LUCKY_DRAW_DRAWING_DETAIL(campaig_id), { params, signal });
}

// get lucky draw detail drawing prize list
export async function getLuckyDrawDetailDrawingPrizeList(params: any, campaign_id: string, member_coupon_id: string, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<PrizeListModel[]>>>> {
  return axios.get<BaseResponse<Pagination<PrizeListModel[]>>>(URL_CAMPAIGN_LUCKY_DRAW_DRAWING_DETAIL_PRIZE_LIST(campaign_id, member_coupon_id), { params, signal });
}


// submitLuckyDrawDrawing
export function submitLuckyDrawDrawing(campaig_id: string, params: {prize_id?: string, member_coupon_id?: string}) {
  return axios.post<BaseResponse<Response<DrawingModel>>>(URL_CAMPAIGN_LUCKY_DRAW_SET_AS_WINNERS(campaig_id), params);
}

// get getSalesPromoList
export async function getSalesPromoList(params: any, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<SalesPromoModel[]>>>> {
  return axios.get<BaseResponse<Pagination<SalesPromoModel[]>>>(`${URL_CAMPAIGN_SALES_PROMO}`, { params, signal });
}

export async function getListWinners(type: 'grand-prize' | 'consolation', campaign_id: string, params: any, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<WinnersModel[]>>>> {
  return axios.get<BaseResponse<Pagination<WinnersModel[]>>>(URL_CAMPAIGN_LUCKY_DRAW_WINNERS(campaign_id, type), { params, signal });
}

// download export list winners
export async function getExportListWinners(campaign_id: string, params?: any) {
  return axios.get<Blob>(URL_CAMPAIGN_LUCKY_DRAW_WINNERS_EXPORT(campaign_id), { params, responseType: 'blob' });
}

// get salesPromoDetail
export async function salesPromoDetail(id: string, params: any, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<SalesPromoModel>>>(`${URL_CAMPAIGN_SALES_PROMO}/${id}`, { params, signal });
}

// get getSalesPromoParticipantList
export async function getSalesPromoParticipantList(campaign_id: string, params: any, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<SalesPromoParticipant[]>>>> {
  return axios.get<BaseResponse<Pagination<SalesPromoParticipant[]>>>(URL_CAMPAIGN_SALES_PROMO_PARTICIPANT(campaign_id), { params, signal });
}

// get getSalesPromoParticipantSummary
export async function getSalesPromoParticipantSummary(campaign_id: string, params: any, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<SalesPromoParticipant>>>(URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_SUMMARY(campaign_id), { params, signal });
}

// download export list participant sales promo
export async function getSalesPromoExportListParticipant(campaign_id: string, params?: any) {
  return axios.get<Blob>(URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_EXPORT(campaign_id), { params, responseType: 'blob' });
}


export async function getSalesPromoParticipantDetail(campaign_id: string, member_id: string, params: any, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<SalesPromoParticipant>>>(URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_DETAIL(campaign_id, member_id), { params, signal });
}

// get getSalesPromoParticipantPrizeList
export async function getSalesPromoParticipantPrizeList(campaign_id: string, participant_id: string, params?: any, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<SalesPromoPrizeModel[]>>>> {
  return axios.get<BaseResponse<Pagination<SalesPromoPrizeModel[]>>>(`${URL_CAMPAIGN_SALES_PROMO_PARTICIPANT_DETAIL(campaign_id, participant_id)}/prizes`, { params, signal });
}

// save Sales Promo General Data
export function saveSalesPromoGeneral(params: SalesPromoModel) {
  if (!params.id) {
    return axios.post<BaseResponse<Response<SalesPromoModel>>>(URL_CAMPAIGN_SALES_PROMO, params);
  }
  return axios.put<BaseResponse<Response<SalesPromoModel>>>(`${URL_CAMPAIGN_SALES_PROMO}/${params.id}`, params);
}

// delete sales promo
export function deleteSalesPromo(campaign_id: string) {
  return axios.delete<BaseResponse<Response<SalesPromoModel>>>(`${URL_CAMPAIGN_SALES_PROMO}/${campaign_id}`);
}

export async function getSalesPromoPrizeList(params: any, campaign_id: string, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<SalesPromoPrizeModel[]>>>> {
  // return axios.get<BaseResponse<Pagination<SalesPromoPrizeModel[]>>>(`${URL_CAMPAIGN_LUCKY_DRAW}`, { params, signal });
  return axios.get<BaseResponse<Pagination<SalesPromoPrizeModel[]>>>(`${URL_CAMPAIGN_SALES_PROMO_PRIZES(campaign_id)}`, { params, signal });
}

export function submitSalesPromoPrize(campaign_id: string, params: any) {
  if (params.id) {
    return axios.put<BaseResponse<Response<SalesPromoPrizeModel>>>(`${URL_CAMPAIGN_SALES_PROMO_PRIZES(campaign_id)}/${params.id}`, params);
  }
  return axios.post<BaseResponse<Response<any>>>(URL_CAMPAIGN_SALES_PROMO_PRIZES(campaign_id), params);
}

// get getSalesPromoPrizeDetail
export async function getSalesPromoPrizeDetail(campaign_id?: string, prize_id?: string, prize_type?: 'rewards'|'product', signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<SalesPromoPrizeModel>>>(`${URL_CAMPAIGN_SALES_PROMO_PRIZES(campaign_id)}/${prize_id}/${prize_type}`, { signal });
}

export function deleteSalesPromoPrize(campaign_id: string, prize_id: string, prize_type: 'rewards'|'product') {
  return axios.delete<BaseResponse<Response<SalesPromoPrizeModel>>>(`${URL_CAMPAIGN_SALES_PROMO_PRIZES(campaign_id)}/${prize_id}/${prize_type}`);
}

// get Sales Promo Rule
export async function getSalesPromoRule(id: string, signal?: AbortSignal): Promise<AxiosResponse<BaseResponse<Pagination<SalesPromoRuleModel[]>>>> {
  return axios.get<BaseResponse<Pagination<SalesPromoRuleModel[]>>>(`${URL_CAMPAIGN_SALES_PROMO}/${id}/rules`, { signal });
}

// save Sales Promo  Rule Data
export function saveSalesPromoRule(id: string, params: SalesPromoModel[]) {
  return axios.post<BaseResponse<Pagination<SalesPromoModel[]>>>(`${URL_CAMPAIGN_SALES_PROMO}/${id}/rules`, params);
}

// save Submit Summary Sales Promo
export function submitSummarySalesPromo(campaign_id: string) {
  return axios.patch<BaseResponse<Response<SalesPromoModel>>>(`${URL_CAMPAIGN_SALES_PROMO_SUMMARY(campaign_id)}`);
}

// get getSalesPromoSelectPrizeMission
export async function getSalesPromoSelectPrizeMission(campaign_id: string, member_id: string, mission_stamp_id: string, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<SalesPromoSelectGiftModel>>>(URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_MISSION(campaign_id,member_id,mission_stamp_id), { signal });
}

export function submitSalesPromoSelectPrizeMission(campaign_id: string, member_id: string, mission_stamp_id: string, params: any) {
  return axios.post<BaseResponse<Response<SalesPromoSelectGiftModel>>>(URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_MISSION(campaign_id,member_id,mission_stamp_id), params);
}

// get getSalesPromoSelectPrizeTransaction
export async function getSalesPromoSelectPrizeTransaction(campaign_id: string, member_id: string, member_sales_promo_id: string, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<SalesPromoSelectGiftModel>>>(URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_TRANSACTION(campaign_id,member_id,member_sales_promo_id), { signal });
}

export function randomizeSalesPromoSelectPrizeTransaction(campaign_id: string, member_id: string, params: any) {
  return axios.put<BaseResponse<Response<SalesPromoSelectGiftPrizesModel>>>(URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_RANDOMIZE(campaign_id,member_id), params);
}

export function submitSalesPromoSelectPrizeTransaction(campaign_id: string, member_id: string, member_sales_promo_id: string, params: any) {
  return axios.post<BaseResponse<Response<SalesPromoSelectGiftModel>>>(URL_CAMPAIGN_SALES_PROMO_SELECT_PRIZE_TRANSACTION(campaign_id,member_id,member_sales_promo_id), params);
}

export async function salesPromoDetailWinnerResult(campaign_id: string, signal?: AbortSignal) {
  return axios.get<BaseResponse<Response<SalesPromoResult>>>(URL_CAMPAIGN_SALES_PROMO_WINNERS(campaign_id), { signal });
}

export async function salesPromoDetailWinnerExport(campaign_id: string, params?: any) {
  return axios.get<Blob>(URL_CAMPAIGN_SALES_PROMO_WINNERS_EXPORT(campaign_id), { params, responseType: 'blob' });
}